
const base  =  '/bank'

export const bankUrls = {
    bank_certificates: `${base}/certificates`,
    bank_certificates_search: `${base}/certificates/search`,
    bank_certificates_view: `${base}/certificates/view`,
    bank_digital_letters: `${base}/digital-letters`,
    bank_digital_letter_external: '/digital-letters/:reference/external',
    bank_user_profile: `${base}/user-profile`,
    bank_transaction_history: `${base}/certificates/:certificateNo/transaction-history`,
    upload_certificate_of_reasonableness: `/cu/vr/:encryted_email/:reference_number/:timestamp`,
    upload_link_verification_error: `/upload/link-verification/error`
}